export enum Gender {
    Man = "mann",
    Woman = "kvinne",
}

export enum AgeGroup {
    Senior = "Senior",
    U23 = "2123",
    Age1920 = "1920",
    Age18 = "18",
    Age17 = "17",
}

export enum SerieType {
    Totalt = "Totalt",
    Sprint = "Sprint",
    Distanse = "Distanse",
}